import clsx from "clsx";
import type { FunctionComponent } from "react";

import Card from "~/components/Card/Card";
import DetailsListDivider from "~/components/DetailsList/components/DetailsListDivider";
import DetailsListItem from "~/components/DetailsList/components/DetailsListItem";
import { getFormattedCurrencyValue } from "~/modules/billing/api/invoiceStatus/invoiceStatusId.ts";
import { formatNumberWithComma } from "~/utils/numberUtils.ts";

type InvoiceAmountDetailProps = {
	bold?: boolean;
	currencySymbol: string;
	label: string;
	valueCents: number;
}

const InvoiceAmountDetail: FunctionComponent<InvoiceAmountDetailProps> = ({
	currencySymbol,
	bold = false,
	label,
	valueCents,
}) => {
	return <DetailsListItem label={label}
							boldLabel={bold}>
		<div className={clsx("w-full text-right", bold && "font-bold", valueCents < 0 && "text-secondary-500")}>{getFormattedCurrencyValue(valueCents, currencySymbol)}</div>
	</DetailsListItem>;
};

type Props = {
	currencySymbol: string;
	onEditClick?: () => void;
	subtotalCents: number;
	totalAmountCents: number;
	travelCostCentsBeforeVat: number;
	vatPercentage: number;
	vatTotalCents: number;
};

const InvoiceTotalsSection: FunctionComponent<Props> = ({
	currencySymbol,
	onEditClick,
	subtotalCents,
	totalAmountCents,
	travelCostCentsBeforeVat,
	vatPercentage,
	vatTotalCents,
}) => {
	return <Card title="Rechnungsbetrag"
				 onHeaderButtonClick={onEditClick}
				 headerButtonText={onEditClick ? "Bearbeiten" : undefined}
				 padding="none">
		<div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 px-4 py-3">
			<InvoiceAmountDetail label="Summe Einzelpositionen"
								 valueCents={subtotalCents}
								 currencySymbol={currencySymbol} />
			<InvoiceAmountDetail label="Reisekosten"
								 valueCents={travelCostCentsBeforeVat}
								 currencySymbol={currencySymbol} />
			<InvoiceAmountDetail label="Rechnungssumme"
								 valueCents={travelCostCentsBeforeVat + subtotalCents}
								 currencySymbol={currencySymbol} />
			<InvoiceAmountDetail label={`MwSt ${formatNumberWithComma(vatPercentage / 100, 2, true)}%`}
								 valueCents={vatTotalCents}
								 currencySymbol={currencySymbol} />
			<DetailsListDivider bold={true} />
			<InvoiceAmountDetail label="Gesamt"
								 valueCents={totalAmountCents}
								 currencySymbol={currencySymbol}
								 bold={true} />
		</div>
	</Card>;
};

export default InvoiceTotalsSection;